module.exports = (minValue = 0, maxValue = 1, precision = 2) => {
  return parseFloat(
    Math.min(minValue + (Math.random() * (maxValue - minValue)), maxValue).toFixed(precision)
  );
}
